import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd';
import { ResetPasswordComponent } from './reset-password.component';

@Injectable({ providedIn:'root' })
export class ResetPasswordService {
    constructor(
        private modalService: NzModalService
    ) {}

    resetPasswordByModal() {
        this.modalService.create({
            nzWidth:420,
            nzTitle: null,
            nzClosable: false,
            nzMaskClosable: false,
            nzFooter: null,
            nzContent: ResetPasswordComponent,
            nzStyle: { 'top': '170px' },
            nzBodyStyle: { 'padding': 0 }
        })
    }
}
